<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div v-if="product" class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4>Añadir Grupo</h4>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div class="form-group" :class="{ 'has-error' : errors.has('Name') }">
								<label class="control-label">Nombre</label>
								<input
									v-validate="'required'"
									v-model="item.name"
									type="text"
									name="Name"
									class="form-control">
									<small v-show="errors.has('Name')" class="form-text text-danger">
										{{ errors.first('Name') }}
									</small>
							</div>
						</div>
						<div class="col-md-12">
							<div class="form-group" :class="{ 'has-error' : errors.has('Products') }">
								<label class="control-label">Productos</label>
								<input v-model="item.product_ids" v-validate="'required'" type="hidden" name="Products">
								<treeselect
									:multiple="true"
									:searchable="true"
									:open-on-focus="true"
									:options="categoriesWithProducts"
									:value-consists-of="'LEAF_PRIORITY'"
									:show-count="true"
									:normalizer="normalizer"
									search-nested
									placeholder="Seleccionar productos"
									:required="true"
									v-model="item.product_ids">
								</treeselect>
								<small v-show="errors.has('Products')" class="form-text text-danger">
									{{ errors.first('Products') }}
								</small>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button ref="btnStore" @click="validate()" type="button" class="btn btn-success">Guardar</button>
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Treeselect from '@riophae/vue-treeselect'

	export default {
		props: ['user', 'isAuth', 'product'],
		components: {
			'treeselect': Treeselect,
		},
		data () {
			return {
				modal: {
					selector: 'modal-product-group-create',
				},

				item: {
					name: null,
					product_id: this.product.id,
					product_ids: [],
				},

				categoriesWithProducts: null,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getCategoriesWithproducts()
			},
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			clearData() {
				this.item.name = null
				this.item.product_id = this.product.id
				this.item.product_ids = []
			},
			getCategoriesWithproducts: function() {
				this.$http.get('admin/management/products/categories/products')
					.then(response => {
						this.categoriesWithProducts = response.body
					})
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.store()
					}
					return result
				})
			},
			store: function() {
				var loading = Ladda.create(this.$refs.btnStore)
				loading.start()
				this.$http.post('admin/management/products/groups', this.item)
					.then(response => {
						loading.stop()
						this.close()
						this.clearData()
						this.$emit('reload')
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					}).catch(function(response) {
						loading.stop()
						console.log(response)
					})
			},
			normalizer(node) {
				var length = null
				if(node.children) {
					if(node.children.length) {
						length = node.children.length
					}
				}
				if(length) {
					var id = 'category-' + node.id
				} else {
					var id = node.id
				}
				return {
					id: id,
					label: node.title,
					children: node.children,
				}
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/products/components/groups/views/Create.vue